import { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface DashboardTileProps {
  title: string;
  children: ReactNode;
  delay?: number;
  className?: string;
  'data-figma-id'?: string;
}

/**
 * Base Dashboard Tile Component
 * From FIGMA export - provides consistent tile styling with motion
 */
export function DashboardTile({
  title,
  children,
  delay = 0,
  className = '',
  'data-figma-id': figmaId,
}: DashboardTileProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay, ease: 'easeOut' }}
      data-figma-id={figmaId}
    >
      <Card className={`shadow-md hover:shadow-lg transition-shadow ${className}`}>
        <CardHeader>
          <CardTitle className="text-xl font-semibold">{title}</CardTitle>
        </CardHeader>
        <CardContent>{children}</CardContent>
      </Card>
    </motion.div>
  );
}

